import { ErrorMessage } from "formik";
import { cn } from "src/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const CustomSelect = ({
	options,
	value,
	onChange,
	placeholder = "Select an option",
	className,
	contentClassName,
	error,
	disabled,
	required,
	name,
	onOpenChange,
	containerClassName,
	label,
	labelClassName,
	id,
	...props
}) => {
	return (
		<div className={cn("tw-w-full", containerClassName)}>
			{!!label && (
				<label htmlFor={id} className={cn("tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-[#495364]", labelClassName)}>
					{label}
				</label>
			)}
			<Select
				value={options.find((option) => String(option.value) === String(value))?.value.toString()}
				onValueChange={onChange}
				disabled={disabled}
				name={name}
				required={required}
				onOpenChange={onOpenChange}
				{...props}
			>
				<SelectTrigger
					className={cn(
						"tw-w-full tw-gap-3 tw-text-gray tw-px-5 tw-py-3 focus:tw-border-primary tw-capitalize",
						value && "!tw-text-black",
						error && "tw-border-destructive !tw-bg-[#FBFBFB] focus:tw-ring-destructive",
						disabled ? "tw-cursor-not-allowed tw-opacity-50" : "",
						className
					)}
				>
					<SelectValue placeholder={placeholder} />
				</SelectTrigger>

				<SelectContent className={cn("tw-min-w-[var(--radix-select-trigger-width)]", contentClassName)}>
					{options.map((option) => (
						<SelectItem
							key={option.value}
							value={String(option.value)}
							className={cn("tw-cursor-pointer tw-capitalize", disabled ? "tw-cursor-not-allowed" : "")}
						>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>

			{!!name && <ErrorMessage name={name} component="div" className="tw-block tw-mt-1 tw-text-xs tw-text-destructive" />}
		</div>
	);
};

export default CustomSelect;
